'use client';

import { c as _c } from "react/compiler-runtime";
import type { ConsentBannerData, ConsentBannerUIProps } from '../../lib/consent-banner-data.ts';
import { useConsentBanner } from './consent-banner.logic.ts';

/**
 * Smart consent banner that wires the useConsentBanner hook to the
 * presentational UI component from ark-skippy.
 */
export const ConsentBanner: React.FC<{
  bannerData: ConsentBannerData;
  testMode?: boolean;
  renderBanner: React.FC<ConsentBannerUIProps>;
}> = t0 => {
  const $ = _c(21);
  const {
    bannerData,
    testMode: t1,
    renderBanner: BannerUI
  } = t0;
  const testMode = t1 === undefined ? false : t1;
  const {
    visible,
    sdkReady,
    onAcceptAll,
    onRejectAll,
    onShowPreferences
  } = useConsentBanner(bannerData, testMode);
  if (!visible) {
    return null;
  }
  let t2;
  if ($[0] !== bannerData.acceptAllButton.text || $[1] !== onAcceptAll) {
    t2 = {
      text: bannerData.acceptAllButton.text,
      onClick: onAcceptAll
    };
    $[0] = bannerData.acceptAllButton.text;
    $[1] = onAcceptAll;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== bannerData.rejectAllButton || $[4] !== onRejectAll) {
    t3 = bannerData.rejectAllButton ? {
      text: bannerData.rejectAllButton.text,
      onClick: onRejectAll
    } : null;
    $[3] = bannerData.rejectAllButton;
    $[4] = onRejectAll;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== bannerData.showPreferencesButton || $[7] !== onShowPreferences || $[8] !== sdkReady) {
    t4 = bannerData.showPreferencesButton ? {
      text: bannerData.showPreferencesButton.text,
      onClick: onShowPreferences,
      disabled: !sdkReady
    } : null;
    $[6] = bannerData.showPreferencesButton;
    $[7] = onShowPreferences;
    $[8] = sdkReady;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== bannerData.policyLinkText || $[11] !== bannerData.policyLinkUrl) {
    t5 = bannerData.policyLinkText && bannerData.policyLinkUrl ? {
      text: bannerData.policyLinkText,
      url: bannerData.policyLinkUrl
    } : null;
    $[10] = bannerData.policyLinkText;
    $[11] = bannerData.policyLinkUrl;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== BannerUI || $[14] !== bannerData.description || $[15] !== bannerData.title || $[16] !== t2 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5) {
    t6 = <BannerUI title={bannerData.title} description={bannerData.description} acceptAllButton={t2} rejectAllButton={t3} showPreferencesButton={t4} policyLink={t5} />;
    $[13] = BannerUI;
    $[14] = bannerData.description;
    $[15] = bannerData.title;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};